/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Popover,
  Row,
  Skeleton,
  DatePicker,
  // Table,
  Tooltip,
} from "antd";
import "./index.css";
import {
  DownloadOutlined,
  DownOutlined,
  ShareAltOutlined,
  PrinterFilled,
} from "@ant-design/icons";
import { ledgerStatementList } from "./data";
// import { useHistory } from "react-router";
import { BiCalendar } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { loadLedgerStatmentList } from "../../store/parties/actions";
import moment from "moment";
import { isEmpty, isNaN } from "lodash";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const LedgerStatement = (props) => {
  const dispatch = useDispatch();
  const { RangePicker } = DatePicker;

  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

  const itemListId = {
    organizationId: props.organizationId,
    partyorvendorId: props.partyId,
    dateFrom: startOfMonth,
    dateTo: endOfMonth,
  };

  //organisation id from login response
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);

  const userName = !isEmpty(userNameDetails) ? userNameDetails.user.name : "";
  const userMobile = !isEmpty(userNameDetails)
    ? userNameDetails.user.mobileNo
    : "";

  console.log(userNameDetails, "userNameDetails");
  console.log(userName, userMobile, "user values");
  //initial state values
  const [loading, setLoading] = useState(false);
  const [mouseEnter, setMouseEnter] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [ledgerData, setLedgerData] = useState({
    startMonth: "",
    endMonth: "",
    startOfMonth: "",
    endOfMonth: "",
  });

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    dispatch(loadLedgerStatmentList(itemListId));
    setLedgerData({
      startMonth: "",
      endMonth: "",
      startOfMonth: startOfMonth,
      endOfMonth: endOfMonth,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.ledgerLoading) {
      dispatch(loadLedgerStatmentList(itemListId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.ledgerLoading]);

  const { ledger_statement_list = [] } = useSelector((state) => state.Parties);

  console.log(ledger_statement_list, "ledger_statement_list");
  //state data's
  const [selectDays, setSelectDays] = useState([]);
  console.log(selectDays, "selectDays");

  const ledgerStatementTable =
    ledger_statement_list && ledger_statement_list.length > 0
      ? ledger_statement_list.map((data, index) => {
          return {
            date: data.date !== null ? data.date : "",
            voucher: data.voucher,
            key: index + 1,
            credit:
              data.credit !== null || !isEmpty(data.credit) ? data.credit : 0,
            debit:
              data.debit != null || data.debit != undefined ? data.debit : 0,
            tdsDeductParty:
              data.tdsDeductedByParty !== null ? data.tdsDeductedByParty : 0,
            tdsDeductSelf: data.tdsDeductedBySelf ? data.tdsDeductedBySelf : 0,
            balance: data.balance ? data.balance : 0,
          };
        })
      : [];

  const totalCredit =
    ledgerStatementTable.length > 0
      ? ledgerStatementTable.reduce((a, b) => a.credit + b.credit)
      : 0;
  const totalDebit =
    ledgerStatementTable.length > 0
      ? ledgerStatementTable.reduce((a, b) => a.debit + b.debit)
      : 0;

  const totalTdsDeduct =
    ledgerStatementTable.length > 0
      ? ledgerStatementTable.reduce(
          (a, b) => a.tdsDeductParty + b.tdsDeductParty
        )
      : 0;
  const totalTdsDeductSelf =
    ledgerStatementTable.length > 0
      ? ledgerStatementTable.reduce((a, b) => a.tdsDeductSelf + b.tdsDeductSelf)
      : 0;
  const totalBalance =
    ledgerStatementTable.length > 0
      ? ledgerStatementTable.reduce((a, b) => a.balance + b.balance)
      : 0;

  const handleDownloadPDF = () => {
    const input = document.getElementById("pdf-content");
    // Specify the id of the element you want to convert to PDF
    setDownloadLoading(true)
    setTimeout(()=> {
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        // const pdf = new jsPDF();
        // // pdf.addSvgAsImage(imgData, "PNG")
        // pdf.addImage(imgData, "PNG",5,5);
        // // pdf.output('datauri')
        // // pdf.addPage();
        // pdf.save("vendors.pdf");
        const pdf = new jsPDF();
        pdf.addImage(imgData, "PNG", 5, 10);
        // pdf.html(imgData, {
  
        //   margin: [10, 10, 10, 10],
        // });
        pdf.save("Vendors.pdf");
     
      });
      setDownloadLoading(false)

    }, 1000)
    
  };

  const handlePrintPDF = () => {
    const input = document.getElementById("pdf-content");
    // Specify the id of the element you want to convert to PDF
    var headstr = "<html><head><title>Booking Details</title></head><body>";
    var footstr = "</body>";
    var newstr = input.innerHTML;
    var oldstr = document.body.innerHTML;
    document.body.innerHTML = headstr + newstr + footstr;
    window.print();
    window.close();
    document.body.innerHTML = oldstr;
    return false;
    // window.print(input)
  };

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Vendor | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid pb-4 mb-4 rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <Row>
            <Col span={8} className="pr-3">
              {loading ? (
                <Skeleton.Input className="w-[100%]"></Skeleton.Input>
              ) : (
                <RangePicker
                  style={{
                    width: 250,
                    height: 40,
                  }}
                  onChange={(date, dateString) => {
                    console.log(date, "date");
                    setSelectDays(dateString);
                    if (dateString) {
                      const startMonth =
                        dateString && dateString.length > 0
                          ? dateString[0]
                          : "";
                      const endMonth =
                        dateString && dateString.length > 0
                          ? dateString[1]
                          : "";
                      const ledgerStatementData = {
                        organizationId: props.organizationId,
                        partyorvendorId: props.partyId,
                        dateFrom: startMonth,
                        dateTo: endMonth,
                      };
                      setLedgerData({
                        ...ledgerData,
                        startMonth: startMonth,
                        endMonth: endMonth,
                      });
                      dispatch(loadLedgerStatmentList(ledgerStatementData));
                    }
                  }}
                  allowClear
                  suffixIcon={<BiCalendar size={18} />}
                  placeholder="Select Calendar"
                  className="ml-2"
                />
              )}
            </Col>
            <Col span={4} className="pr-3">
              {loading ? (
                <Skeleton.Input className="w-[100%]"></Skeleton.Input>
              ) : (
                <div
                  onClick={handleDownloadPDF}
                  className="cursor-pointer flex border p-2 rounded-md border-1 text-center"
                >
                  <DownloadOutlined className="text-[16px] mr-3" /> Download
                </div>
              )}
            </Col>
            <Col span={4} className="pr-3">
              {loading ? (
                <Skeleton.Input className="w-[100%]"></Skeleton.Input>
              ) : (
                <div
                  onClick={handlePrintPDF}
                  className="cursor-pointer flex border p-2 rounded-md  border-1 text-center"
                >
                  <PrinterFilled className="text-[16px] mr-3" /> Print
                </div>
              )}
            </Col>
            <Col span={4} className="pr-3">
              {loading ? (
                <Skeleton.Input className="w-[100%]"></Skeleton.Input>
              ) : (
                <div className="text-start">
                  <Popover
                    placement="bottomRight"
                    trigger={"click"}
                    content={ledgerStatementList}
                  >
                    <Tooltip
                      title="Easily perform bulk actions on all your Parties"
                      placement="left"
                      rootClassName="text-[10px]"
                    >
                      <div className="border rounded-sm flex justify-between w-[150px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
                        <div>
                          <ShareAltOutlined className="mr-2" />
                          Share
                        </div>
                        <DownOutlined />
                      </div>
                    </Tooltip>
                  </Popover>
                </div>
              )}
            </Col>
          </Row>
        </Col>
        <Col span={24} className="mt-4 mb-8 pb-6">
          <div
            onMouseEnter={() => setMouseEnter(true)}
            onMouseLeave={() => setMouseEnter(false)}
            className={
              mouseEnter
                ? "border border-1 rounded-md p-3 mb-3 add-ledger-statment-main"
                : "border border-1 rounded-md p-3"
            }
          >
            <Row className="flex justify-center">
              <Col className={downloadLoading ? "pr-16 pt-4 pb-4" : ""}>
                <Row id="pdf-content">
                  <Col
                    span={24}
                    className="flex pb-3 pt-3 justify-between border border-b-2 border-x-0 border-t-0"
                  >
                    <div className="">
                      <h1 className="font-semibold party-label text-[18px]">
                        {userName}
                      </h1>
                      <p className="party-label">Phone no: {userMobile}</p>
                    </div>
                    <h1 className="text-[14px] mt-2 party-label">
                      Party Ledger
                    </h1>
                  </Col>
                  <Col span={24} className="pt-2 flex justify-between">
                    <div className="">
                      <h1 className="party-label text-[12px]">To,</h1>
                      <p className="party-label font-semibold text-[14px]">
                        {props.partyName ? props.partyName : ""}
                      </p>
                    </div>
                    <div className="border border-2 p-2">
                      <h1 className="border text-end border-b-2 pb-2 party-label pl-2 border-x-0 border-t-0">
                        {!isEmpty(ledgerData.startMonth)
                          ? ledgerData.startMonth
                          : ledgerData.startOfMonth}{" "}
                        -
                        {!isEmpty(ledgerData.endMonth)
                          ? ledgerData.endMonth
                          : ledgerData.endOfMonth}
                      </h1>
                      <div className="mt-1">
                        <h1 className="text-end text-[12px] party-label">
                          Total Payable
                        </h1>
                        <p className="text-end text-[16px] party-label font-semibold">
                          {totalBalance}
                        </p>
                      </div>
                    </div>
                  </Col>
                  {/* table ledger statement */}
                  <Col span={24} className="mt-3 add-create-item-table">
                    <table className="mb-6 table-purchase-serial table-responsive">
                      <thead>
                        <tr className="table-head-main">
                          <th className="table-purchase-head text-[12px] font-semibold">
                            Date
                          </th>
                          <th className="table-purchase-head text-[12px] font-semibold">
                            Voucher
                          </th>
                          {/* <th className="table-purchase-head text-[12px] font-semibold">
                        Sr No
                      </th> */}
                          <th className="table-purchase-head text-[12px] font-semibold">
                            Credit
                          </th>
                          <th className="table-purchase-head text-[12px] font-semibold">
                            Debit
                          </th>
                          <th className="table-purchase-head text-[12px] font-semibold">
                            TDS deducted by party
                          </th>
                          <th className="table-purchase-head text-[12px] font-semibold">
                            TDS deducted by self
                          </th>
                          <th className="table-purchase-head text-[12px] font-semibold">
                            Balance
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ledgerStatementTable.map((data, index) => {
                          return (
                            <tr key={index} className="table-purchase-row">
                              <td className="p-3">{data.date}</td>
                              <td className="p-3">{data.voucher}</td>
                              {/* <td className="p-3">{data.sNo}</td> */}
                              <td className="p-3">{data.credit}</td>
                              <td className="p-3">{data.debit}</td>
                              <td className="p-3">{data.tdsDeductParty}</td>
                              <td className="p-3">{data.tdsDeductSelf}</td>
                              <td className="p-3">{data.balance}</td>
                            </tr>
                          );
                        })}

                        <tr className="table-purchase-row">
                          <td
                            className="p-3 font-semibold text-center text-[14px]"
                            colSpan={2}
                          >
                            {"Total"}
                          </td>
                          {/* <td className="p-3">{data.sNo}</td> */}
                          <td className="p-3">
                            {isNaN(totalCredit) ? totalCredit : 0}
                          </td>
                          <td className="p-3">
                            {isNaN(totalDebit) ? totalDebit : 0}
                          </td>
                          <td className="p-3">{totalTdsDeduct}</td>
                          <td className="p-3">{totalTdsDeductSelf}</td>
                          <td className="p-3">{totalBalance}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

LedgerStatement.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default LedgerStatement;
